import { getItemHref } from "@/app/navigation/item"
import type { NftId } from "@anaconda/core/nft/types"
import { useEffect, useState } from "react"

export const useItemFullUrl = (itemId: NftId) => {
  const relativeUrl = getItemHref(itemId)
  const [fullUrl, setFullUrl] = useState(relativeUrl)

  useEffect(() => {
    setFullUrl(`${window.location.origin}${relativeUrl}`)
  }, [relativeUrl])

  return fullUrl
}
